import type { ErrorType } from '../../api/interface/vertify';

export type UnauthorizedHandler = (error: Pick<ErrorType, 'code'>) => boolean;

let unauthorizedHandler: UnauthorizedHandler | undefined;

export const registerUnauthorizedHandler = (handler: UnauthorizedHandler): (() => void) => {
  unauthorizedHandler = handler;
  return () => {
    if (unauthorizedHandler === handler) {
      unauthorizedHandler = undefined;
    }
  };
};

export const tryHandleUnauthorized: UnauthorizedHandler = (error) =>
  unauthorizedHandler?.(error) ?? false;
